import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

const ServiceNowCancelledIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon viewBox="0 0 28 28" fill="none" {...props}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0936 1.16602C6.33817 1.16602 0 7.42545 0 15.1809C0 19.0389 1.5747 22.7788 4.40916 25.4164C5.39335 26.3612 6.92868 26.44 8.03097 25.6132C11.5741 22.9756 16.4556 22.9756 19.9987 25.6132C21.101 26.44 22.6363 26.3612 23.6205 25.4164C29.2501 20.0624 29.4863 11.1654 24.1323 5.53581C21.534 2.78008 17.8729 1.20538 14.0936 1.16602ZM14.0148 22.2276C10.2356 22.3457 7.08615 19.3538 7.00742 15.6139C7.00742 15.4958 7.00742 15.3777 7.00742 15.2596C7.00742 11.4016 10.1568 8.25217 14.0148 8.25217C17.8729 8.25217 21.0223 11.4016 21.0223 15.2596C21.1404 19.0389 18.1484 22.1489 14.4085 22.267C14.251 22.2276 14.1329 22.2276 14.0148 22.2276Z"
      fill="#7D858C"
    />
  </SvgIcon>
);

export default ServiceNowCancelledIcon;
